import React, { useState } from 'react'

export function ContractAmountInput({
  value,
  error,
  setValue,
}: {
  value: number | undefined
  error: string | undefined
  setValue: (value: number) => void
}): JSX.Element {
  const [input, setInput] = useState<string | undefined>(value ? (value / 100).toString() : undefined)

  return (
    <>
      <div className="flex flex-row items-center justify-center h-12 w-60 py-1 pl-4 text-base lg:text-lg bg-cents-grey rounded-2xl">
        €
        <input
          type={'text'}
          value={input}
          className={`border-0 bg-cents-grey w-48 lg:text-lg text-base focus:ring-0`}
          onChange={event => {
            setValue(Math.round(parseFloat(event?.target.value.replace(',', '.')) * 100))
            setInput(event?.target.value)
          }}
        />
      </div>
      {error && (
        <div className="h-4 mb-4 text-red-500">
          <p>{error}</p>
        </div>
      )}
    </>
  )
}
